export default class Integer {
  static name = 'Integer'

  static parse (value) {
    if (_.isString(value)) {
      return Number.parseInt(value)
    } else {
      return value
    }
  }

  static encode (value) {
    if (_.trim(value) === '') {
      return null
    } else {
      return Math.round(value)
    }
  }
}
